import moment from 'moment-timezone'

// A movie start date has two shapes: the calendar day the UI shows and edits
// ("YYYY-MM-DD") and pmMovies.startingDate, which MCS stores as midnight in the
// cinema's own timezone. These two functions are the only place either
// conversion lives.

const DAY_LENGTH = 'YYYY-MM-DD'.length

// The calendar day a start date value means, as "YYYY-MM-DD", or null. Besides
// a day string it accepts what the movie edit form can hold: a JS Date when
// freshly picked in the datepicker (its local day) and a timestamp such as the
// stored pm value (the day it falls on in `timezone`, UTC when missing).
export const toStartingDateString = (raw, timezone) => {
    if (raw instanceof Date) {
        return `${raw.getFullYear()}-${String(raw.getMonth() + 1).padStart(2, '0')}-${String(raw.getDate()).padStart(2, '0')}`
    }
    if (!raw) {
        return null
    }
    return raw.length > DAY_LENGTH ? moment.tz(raw, timezone || 'UTC').format('YYYY-MM-DD') : raw
}

// Midnight of that day in the cinema's timezone as an ISO string, or null
// for no day. Without a timezone it falls back to UTC.
export const toPmStartingDate = (raw, timezone) => {
    const day = toStartingDateString(raw, timezone)
    return day ? moment.tz(day, timezone || 'UTC').startOf('day').toISOString() : null
}
